import library from "./library";

export const libraryLabel = name => name.replace(/\/$/, "").replace("5 Note Arps", "5 Note Arpeggios");

// Folder IDs in generated content are positional. Persist names instead so adding
// a public chart cannot shift a user's chosen folder to a different category.
export function libraryFolders(rows = library, parents = []) {
  return rows.flatMap(row => {
    if (!row.children) return [];
    const parts = [...parents, row.name.replace(/\/$/, "")];
    return [{ path: parts.join("/"), label: `Library / ${parts.map(libraryLabel).join(" / ")}` },
      ...libraryFolders(row.children, parts)];
  });
}
export const libraryLocations = [{ path: "", label: "Library (root)" }, ...libraryFolders()];

export function personalLibraryTree(items, rows = library) {
  const known = new Set(libraryLocations.map(folder => folder.path));
  const byPath = new Map();
  for (const item of items) {
    const path = known.has(item.library_path) ? item.library_path : "";
    if (!byPath.has(path)) byPath.set(path, []);
    byPath.get(path).push({ id: `saved-${item.id}`, name: item.title || "Untitled chart",
      slug: `library/saved/${item.id}`, personal: true });
  }
  const merge = (entries, parents = []) => [...entries.map(entry => {
    if (!entry.children) return entry;
    const parts = [...parents, entry.name.replace(/\/$/, "")];
    return { ...entry, children: merge(entry.children, parts) };
  }), ...(byPath.get(parents.join("/")) || []).sort((a, b) => a.name.localeCompare(b.name))];
  return merge(rows);
}
